import { isDevMode } from '@angular/core';
import { setupWorker } from 'msw/browser';

import { handlers } from './handlers';

const worker = setupWorker(...handlers);

export const enableMockWorker = () => {
  if (isDevMode()) {
    console.log('MSWJS START');
    worker.start({
      onUnhandledRequest: 'bypass'
    });
  } else {
    worker.stop();
  }
};
